<app-management-sidemenu [(isOpen)]="isSideNavOpen"
                         [managementType]="selectedManagementType"
                         [actionType]="selectedActionType"
                         (close)="isSideNavOpen = false"
                         [selectedSupport]="selectedSupport"
                         (refreshTable)="refreshTableAfterAction()">
  <h1 class="heading">{{'SupportManagement' | localize}}</h1>
  <div class="user-management-container  custom-admin-label-class">
    <div class="user-management-header">
      <div class="user-management-process">
        <button class="add-new-user"
                style="cursor: pointer"
                (click)="openSideNav(ManagementType.SupportManagement,ActionType.Create)">
          <span style="font-size: 12.5px; font-family: 'Roboto', sans-serif; color: #777777;">{{'newQuestion' | localize}}</span>
          <img src="assets/icons/general/add-icon.png" alt="" />
        </button>
        <button class="add-new-user"
                style="cursor: pointer"
                matTooltip="{{'fileOperation' | localize}}"
                [matMenuTriggerFor]="menu">
          <img src="assets/icons/fileoperation/ExcelImportResultBlue.png" alt="" />
        </button>
        <mat-menu #menu="matMenu">
          <input hidden #fileInput name='inputFile' id="file" type="file" (change)="fileUpload($event)" multiple="false"
                 accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
          <button *ngIf="authControl('AddSupport')" mat-menu-item (click)="fileInput.click()">
            <mat-icon>publish</mat-icon>
            <span>{{'uploadExcel' | localize}}</span>
          </button>
          <button mat-menu-item (click)="exportExcel()">
            <mat-icon>file_copy</mat-icon>
            <span>{{'downloadSupportExcel' | localize}}</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <div class="table-responsive">
        <mat-table [dataSource]="dataSource">
          <!-- question Column -->
          <ng-container matColumnDef="supportTitle">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label style="font-weight: 600; color: #777777; font-size: 14px;">{{'questionField' | localize}}</mat-label>
                <input [(ngModel)]="inputValues['supportTitle']"
                       matInput
                       (input)="onInputChange($event, false, 'supportTitle')" />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"
                      matTooltip="{{ element.supportTitle }}"
                      matTooltipClass='custom-tool-tip'
                      matTooltipPosition="below">
              {{ element.supportTitle }}
            </mat-cell>
          </ng-container>

          <!-- options Column -->
          <ng-container matColumnDef="options">
            <mat-header-cell class="options-column" *matHeaderCellDef>
              #
            </mat-header-cell>
            <mat-cell class="options-cell" *matCellDef="let element">
              <button mat-icon-button
                      [matMenuTriggerFor]="actionMenu"
                      aria-label="Options">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu class="options-menu" #actionMenu="matMenu">
                <div class="menu-header">{{ 'transactions' | localize}}</div>
                <button mat-menu-item
                        (click)="
                    openSideNav(
                      ManagementType.SupportManagement,
                      ActionType.Update,
                      element
                    )
                  ">
                  <img src="assets/icons/general/edit-project-icon.png"
                       alt="" />
                  {{ 'edit' | localize}}
                </button>

                <button mat-menu-item
                        (click)="deleteQA(element)">
                  <img src="assets/icons/general/delete-project-icon.png"
                       alt="" />
                  {{'deleteQA' | localize}}
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>

          <!-- Define rows -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>

      <!--Paginator-->
      <div class="custom-paginator">
        <span *ngIf="userSearchLength > 0; else noRecords">
          {{ userSearchLength }} {{ 'entries' | localize }} {{ currentPage * pageSize + 1 }} -
          {{ Math.min(userSearchLength, (currentPage + 1) * pageSize) }}
          {{ 'betweenDisplayed' | localize }}
        </span>
        <ng-template #noRecords> {{ 'noRecordFound' | localize }} </ng-template>

        <!-- Paginator Buttons -->
        <button (click)="onPageChange(0)" [disabled]="currentPage === 0">
          &laquo;
        </button>
        <button (click)="onPageChange(currentPage - 1)"
                [disabled]="currentPage === 0">
          &lt;
        </button>
        <ng-container *ngFor="let page of visiblePageNumbers">
          <button [class.active]="page - 1 === currentPage"
                  (click)="onPageChange(page - 1)">
            {{ page }}
          </button>
        </ng-container>
        <button (click)="onPageChange(currentPage + 1)"
                [disabled]="currentPage >= totalPages - 1">
          &gt;
        </button>
        <button (click)="onPageChange(totalPages - 1)"
                [disabled]="currentPage >= totalPages - 1">
          &raquo;
        </button>
        <!--PageSize selection-->
        <select [(ngModel)]="pageSize" (change)="updatePageSize($event)">
          <option *ngFor="let option of [5, 10]" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
</app-management-sidemenu>
